import React, { Component } from 'react';

import { Link } from 'react-router-dom';

function User({
  id,
  name,
  surname,
  gender,
  age,
  country,
  email,
  imgSrc,
  updateCoords,
}) {
  return (
    <div id={id} className="user">
      <div className="user-data">
        <div className="user-img">
          <img src={imgSrc} alt="" />
        </div>
        <div className="user-info">
          <h2 className="name">
            {name} {surname}
          </h2>
          <button
            type="button"
            className="country"
            onClick={(e) => updateCoords(e, id)}
            onKeyDown={updateCoords}
          >
            <span role="img" aria-label="Location">
              📌
            </span>
            {country}
          </button>
          <Link className="user-page" to={id}>
            <span role="img" aria-label="Detailed information">
              ℹ{' '}
            </span>
            User page
          </Link>
        </div>
      </div>
    </div>
  );
}

export default User;
